import { Shop } from '../shops/shop.model';
import { Order } from '../order/order.model';
import { OrderBatch } from '../order-batch/order-batch.model';
import { ServiceLevel } from '../../sharedModule/models/service-level.model';
import {
  CarrierTypeNames,
  CarrierProvidersNames,
  CarriersFieldsTypes,
  FreightServiceType,
} from '@pdqdev/pdq-shared/dist/CarrierData';
import { CarrierProviders } from '@pdqdev/pdq-shared/dist/entities';
import { ECommerceSubTenant } from '@pdqdev/pdq-shared/dist/entities';
export interface Carrier {
  id: number;
  name: string;
  type: CarrierTypes;
  customerKey: string;
  customerPassword: string;
  customerProp1: string;
  customerProp2: string;
  isActive: boolean;
  isTestMode?: boolean;
  isMasterCarrierAccount?: boolean;
  isLinkedCarrierAccount?: boolean;
  orders?: Order[];
  orderBatches?: OrderBatch[];
  serviceLevels?: ServiceLevel[];
  secret: string;
  comment: string;
  method: string;
  footerNote: string;
  labelConfiguration?: { labelFormat: string };
  shop?: Shop;
  metadata?: CarrierMetaDataField[] | null;
  labelTemplateFile?: string;
  isMultiCarrier?: boolean;
  freightServiceType: FreightServiceType[];
  providers: CarrierProviders[];
  eCommerceSubTenants?: ECommerceSubTenant[];
  haveInternalRatesCards?: boolean;
}

export interface CarrierTypes {
  id: number;
  name: CarrierTypeNames;
  custom_fields: any;
  providers?: { id: number; name: CarrierProvidersNames }[];
}

export interface CarrierMetaDataField {
  fieldName: string;
  displayName: string;
  type: CarrierMetaDataType;
  default: any;
  options?: string[] | any;
}

export enum CarrierMetaDataType {
  NUMBER = 'Number',
  TEXT = 'Text',
  CHECKBOX = 'Checkbox',
  DATE_TIME = 'DateTime',
  TIME = 'Time',
}

export interface CarrierFieldConfig {
  fieldName: string;
  displayName: string;
  type: CarriersFieldsTypes;
  defaultValue: any;
  /* configs for Field type Select*/
  options?: object[];
  optionValue?: string;
  optionLabel?: string;
}

export interface CarrierFields {
  defaultFields: CarrierSingleField[];
  metaDataFields: CarrierSingleField[];
  providersFields: CarrierProvidersSingleField[];
}

export interface CarrierProvidersSingleField extends CarrierSingleField {
  providers: CarrierSingleField[];
}

export interface CarrierSingleField {
  displayName: string;
  fieldName: string;
  type: CarriersFieldsTypes;
  default?: any;
  defaultMappings?: any;
  options?: string[] | any;
  additionalValueOptions?: string[] | any;
  placeHolder?: string;
  descriptionText?: string;
  isRequired?: boolean;
  isNotRequiredOnTestMode?: boolean;
  isReadonly?: boolean;
  isHidden?: boolean;
  optionValue?: string;
  optionLabel?: string;
  defaultValue?: string | boolean;
  newKeyPlaceholder?: string;
  isNotEditable?: boolean;
  enableOnlyInEditMode?: boolean;
  dependentField?: string;
  generalSettings?: any;
  validate?: {
    pattern?: string;
    errorMessage?: string;
  };
}
